import React, { useState } from 'react'
import { Box } from '@mui/material'
import { DeepcellPrimaryButton } from 'components/shared'
import { useCellVisualizationsSlice } from 'redux/slices/hooks/useCellVisualizationsSlice'
import { useXGBoostAccess } from 'utils/useXGBoostAccess'
import TrainClassifierDialog, { TrainClassifierDialogProps } from './TrainClassifierDialog'

export const TrainClassifierButton = (): JSX.Element => {
  const [trainClassifierProps, setTrainClassifierProps] = useState<TrainClassifierDialogProps | undefined>(undefined)
  const {
    cellVisualizations: { projection_params: projectionParams },
  } = useCellVisualizationsSlice()
  const hasXGBoostAccess = useXGBoostAccess()

  const isUMAP = projectionParams?.method !== 'tSNE'
  const isTSNE = projectionParams?.method === 'tSNE'

  // Enable button for UMAP (always) or tSNE (when user has XGBoost access)
  const isButtonEnabled = isUMAP || (isTSNE && hasXGBoostAccess)

  const handleTrainClassifer = () => {
    setTrainClassifierProps({})
  }

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
        <DeepcellPrimaryButton
          outlined
          sx={{ width: '66%' }}
          onClick={handleTrainClassifer}
          disabled={!isButtonEnabled}
        >
          Train Classifier
        </DeepcellPrimaryButton>
      </Box>

      <TrainClassifierDialog
        {...trainClassifierProps}
        open={Boolean(trainClassifierProps)}
        onClose={() => setTrainClassifierProps(undefined)}
      />
    </>
  )
}

export default TrainClassifierButton
